import createDecorator from "final-form-calculate";

const filtered = (allowed, object) =>
  Object.keys(object)
    .filter((key) => allowed.includes(key))
    .reduce((obj, key) => {
      obj[key] = object[key];
      return obj;
    }, {});

const allowed790A = [
  "eta_790a_a6b_hours_sunday",
  "eta_790a_a6c_hours_monday",
  "eta_790a_a6d_hours_tuesday",
  "eta_790a_a6e_hours_wednesday",
  "eta_790a_a6f_hours_thursday",
  "eta_790a_a6g_hours_friday",
  "eta_790a_a6h_hours_saturday",
];

const decorator790A = createDecorator({
  field: /eta_790a_a6._hours_.{6,9}/, // when a field matching this pattern changes...
  updates: {
    // ...update the total to the result of this function
    eta_790a_a6a_hours_total: (ignoredValue, allValues) =>
      Object.values(filtered(allowed790A, allValues)).reduce(
        (sum, value) => sum + Number(value || 0),
        0
      ),
  },
});

const allowed9142B = [
  "jobHoursSun",
  "jobHoursMon",
  "jobHoursTues",
  "jobHoursWed",
  "jobHoursThu",
  "jobHoursFri",
  "jobHoursSat",
];

const decorator9142B = createDecorator({
  field: /jobHours.{3,5}/, // when a field matching this pattern changes...
  updates: {
    // ...update the total to the result of this function
    jobHoursTotal: (ignoredValue, allValues) =>
      Object.values(filtered(allowed9142B, allValues)).reduce(
        (sum, value) => sum + Number(value || 0),
        0
      ),
  },
});

const allowed9142C = [
  "eb6b_hours_sunday",
  "eb6c_hours_monday",
  "eb6d_hours_tuesday",
  "eb6e_hours_wednesday",
  "eb6f_hours_thursday",
  "eb6g_hours_friday",
  "eb6h_hours_saturday",
];

const decorator9142C = createDecorator({
  field: /eb6._hours_.{6,9}/, // when a field matching this pattern changes...
  updates: {
    // ...update the total to the result of this function
    eb6a_hours_total: (ignoredValue, allValues) =>
      Object.values(filtered(allowed9142C, allValues)).reduce(
        (sum, value) => sum + Number(value || 0),
        0
      ),
  },
});

// Sync F.10a (offered wage period) with F.11a (prevailing wage period) for 9035 form
const decorator9035WageSync = createDecorator({
  field: "_section_f_f11a_prevailing_wage_per",
  updates: {
    _section_f_f10a_nonimmigrant_wage_per: (
      _ignoredValue,
      allValues
    ) => allValues._section_f_f11a_prevailing_wage_per || undefined,
  },
});

const decorators = [decorator790A, decorator9142B, decorator9142C, decorator9035WageSync];
export default decorators;
